module.exports = __webpack_public_path__ + "img/SD.25d5ef6c.png";